var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrUpRightIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5131 10.4423L11.7679 16.1876C11.6507 16.3048 11.4917 16.3706 11.3259 16.3706C11.1602 16.3706 11.0012 16.3048 10.884 16.1876C10.7668 16.0703 10.7009 15.9114 10.7009 15.7456C10.7009 15.5799 10.7668 15.4209 10.884 15.3037L15.5625 10.6252L2.92906 10.6257C2.7632 10.6257 2.60415 10.5598 2.48687 10.4426C2.36959 10.3253 2.30371 10.1662 2.30371 10.0004C2.30371 9.83452 2.36959 9.67546 2.48687 9.55818C2.60415 9.44091 2.76321 9.37502 2.92906 9.37502L15.5625 9.37558L10.884 4.69707C10.7668 4.57986 10.701 4.42089 10.701 4.25513C10.701 4.08937 10.7668 3.9304 10.884 3.81319C11.0012 3.69598 11.1602 3.63013 11.326 3.63013C11.4917 3.63013 11.6507 3.69598 11.7679 3.81319L17.5131 9.55843C17.6303 9.67564 17.6962 9.83461 17.6962 10.0004C17.6962 10.1661 17.6303 10.3251 17.5131 10.4423Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrUpRightIc);
export default __webpack_public_path__ + "static/media/ArrUpRight_ic.cf3519ec.svg";
export { ForwardRef as ReactComponent };